import type { DocPageContent } from '../docs-content'

const page = {
  order: 16,
  slug: 'scene-browser',
  title: 'Navegador de Escenas y Análisis con IA',
  description:
    'Analiza medios localmente para generar subtítulos de escenas, luego busca por palabra clave, significado o color.',
  category: 'Herramientas Creativas',
  related: ['media', 'local-ai', 'source-monitor'],
  sections: [
    {
      title: 'Analizar con IA',
      blocks: [
        {
          kind: 'list',
          items: [
            'Ejecuta **Analizar con IA** en un clip desde la biblioteca de medios, o desde el menú **Analizar** del Navegador de Escenas.',
            'El proceso se ejecuta completamente en tu máquina: detecta escenas, subtitula cada una, extrae una paleta de colores y construye incrustaciones (embeddings) de texto e imagen.',
            'Elige **Analizar medios nuevos** para clips sin subtítulos, o **Re-analizar todo** para actualizar todo.',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'Los resultados se almacenan en caché por contenido, por lo que los medios idénticos se reutilizan en lugar de analizarse de nuevo.',
        },
      ],
    },
    {
      title: 'Abrir el Navegador de Escenas',
      blocks: [
        {
          kind: 'list',
          items: [
            'Abre el Navegador de Escenas desde la biblioteca de medios, o con `Ctrl+Mayús+F`.',
            'Busca en los subtítulos generados por IA y los datos de escena producidos por Analizar con IA.',
            'Establece el alcance a todos los medios analizados o a un solo clip, y ordena por **Relevancia**, **Marca de tiempo** o **Nombre del medio**.',
            'Cambia entre **Vista de lista** y **Vista de cuadrícula** según prefieras navegar o escanear.',
          ],
        },
      ],
    },
    {
      title: 'Modos de búsqueda',
      blocks: [
        {
          kind: 'table',
          headers: ['Modo', 'Coincide por'],
          rows: [
            ['Palabra clave', 'Las palabras exactas en un subtítulo — útil para un objeto o etiqueta específica.'],
            [
              'Semántico',
              'Significado, por lo que "atardecer sobre el agua" encuentra escenas relacionadas (la primera descarga descarga un modelo pequeño, ~22 MB).',
            ],
            ['Color', 'Una paleta similar — elige una muestra de la paleta de la biblioteca.'],
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'Los resultados muestran insignias de coincidencia — Fuerte, Buena o Justa — y señalan si la coincidencia fue por palabra clave, significado, similitud visual o color.',
        },
      ],
    },
    {
      title: 'Usar un resultado',
      blocks: [
        {
          kind: 'list',
          items: [
            'Haz clic en una escena para previsualizarla en el monitor de origen.',
            'Arrastra una escena a la línea de tiempo para añadir ese momento a tu edición.',
            'Si no se encuentra nada, confirma que el clip ha sido analizado — solo los medios analizados son buscables.',
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page